import { UserModel } from "model";

// import { BUILD_PROFILE } from "./build";

// To toggle off a feature only in prod, you can set the value like:
// EXPORT_REQUESTS: BUILD_PROFILE !== "prod"

export function getFeatureFlags(user?: UserModel) {
  return {
    // Default rules
    SUB_MAP_TOOL: user?.isSuperAdmin,
    WAITLIST_TOOL: user?.isSuperAdmin,
    BILLING_PAGE: user?.isSuperAdmin || user?.isBillingAdmin,
  };
}
